import { Skeleton } from '../styled'

const CategoryFilterLoadingState = () => {
  return <Skeleton variant="rectangular" width="100%" height={96} animation="wave" />
}

export default CategoryFilterLoadingState
